import { ref} from "vue";

export function useChatEnums() {

    const callEnums = ref({
        IN_PROGRESS: 'IN_PROGRESS',
        CANCELED: 'CANCELED',
        ENDED: 'ENDED'
    })

    const actionEnums = ref({
        ADD_USER: 'ADD_USER',
        REMOVE_USER: 'REMOVE_USER'
    })

    const groupTypeEnums = ref({
        PUBLIC: 'PUBLIC',
        PRIVATE: 'PRIVATE',
        CLIENT_SERVICE: 'CLIENT_SERVICE'
    })


    return { callEnums, actionEnums, groupTypeEnums }
}
